import React from 'react'

import { getDatesFromOffset } from '../../utils/getDatesFromOffset'
import { CardType, useOdsVdpViewsCountQuery } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { BasicWidgetProps } from '../../types'

const VDPViews: React.FC<BasicWidgetProps> = ({
    config: { text = 'Vehicle', text2 = 'VDP Views', secondaryText = 'in the last 7 days', offset },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps) => {
    const { startDate, endDate } = getDatesFromOffset(offset, {
        start: -6,
        end: 0,
    })

    const { data, loading } = useOdsVdpViewsCountQuery({
        variables: { endDate, startDate },
    })

    const { startDate: detailStartDate, endDate: detailEndDate } = getDatesFromOffset(offset, { start: -29, end: 0 })

    const count = data?.auction?.card?.vdpViewsCount || '--'

    return (
        <SingleNumberWidget
            cardType={CardType.PIPELINE}
            action={{
                text: 'View Vehicles',
                link: `/vdpviews?startDate=${detailStartDate}&endDate=${detailEndDate}`,
            }}
            loading={loading}
            number={count}
            text={text}
            text2={text2}
            secondaryText={secondaryText}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default VDPViews
